import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../stores/Store';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import BulkImportEditRows from './BulkImport/BulkImportEditRows';
import BulkImportSelectRows from './BulkImport/BulkImportSelectRows';
import { reset, setBulkImportStep } from '../../stores/ImportStore';

function BulkImport() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bulkImportStep, importResponse } = useSelector((state: RootState) => state.importReducer);

  /**
   * Handle the close action
   */
  const handleClose = () => {
    navigate('/import/file');
    dispatch(reset());
  };

  useEffect(() => {
    if (!importResponse) {
      handleClose();
    }
  }, []);

  /**
   * Handle the back button of the drawer to close or to go back a bulkImportStep
   */
  const handleBackButton = () => {
    if (bulkImportStep === 1 || (bulkImportStep === 2 && importResponse && !importResponse.hasErrors)) {
      handleClose();
    } else {
      dispatch(setBulkImportStep(bulkImportStep - 1));
    }
  };

  /**
   * Render each step of sim swap journey
   */
  const renderSteps = () => {
    switch (bulkImportStep) {
      case 1:
        return <BulkImportEditRows onBack={handleBackButton} />;
      case 2:
        return <BulkImportSelectRows onBack={handleBackButton} />;
      default:
        return null;
    }
  };

  return (
    <Box>
      <Breadcrumbs
        activeLinks={[
          { label: t('navbar.import'), url: `/import` },
          { label: t('pages.importFile.title'), url: `/import/file`, onClick: handleBackButton },
          ...(bulkImportStep === 2 && importResponse && importResponse.hasErrors
            ? [
                {
                  label: t('pages.bulkImport.breadcrumbs.review'),
                  url: `/import/bulk`,
                  onClick: handleBackButton,
                },
              ]
            : []),
        ]}
        disabledLinks={[
          t(bulkImportStep === 1 ? 'pages.bulkImport.breadcrumbs.review' : 'pages.bulkImport.breadcrumbs.summary'),
        ]}
      />
      {renderSteps()}
    </Box>
  );
}

export default BulkImport;
